import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHero } from "@/components/common/PageHero";
import { Seo } from "@/components/common/Seo";
import { IMAGES } from "@/content/site";

export default function LegalPage({ slug }) {
  const [doc, setDoc] = useState(undefined);
  useEffect(() => {
    api.get(`/api/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setDoc(null));
  }, [slug]);

  const title = doc?.title || "Legal";
  return (
    <div data-testid={`page-legal-${slug}`}>
      <Seo title={`${title} | Azeka Global`} description={`${title} — Azeka Global (AZEKA GLOBAL TRADE FZCO).`} path={`/${slug}`} />
      <PageHero eyebrow="Legal" title={title} image={IMAGES.warehouse} />
      <section className="container-x max-w-3xl py-16 lg:py-24">
        {doc === undefined ? (
          <p className="text-ink-muted">Loading…</p>
        ) : doc === null ? (
          <p className="text-ink-muted">This document is not available.</p>
        ) : (
          <div className="prose prose-slate max-w-none text-ink-body leading-relaxed" data-testid="legal-body"
               dangerouslySetInnerHTML={{ __html: doc.body }} />
        )}
      </section>
    </div>
  );
}
